import {
  OPEN_FROM_DATE,
  OPEN_TO_DATE,
  SET_DATES,
  CLOSE_CALENDAR,
} from "./reducer"

export const openFromDate = (minDate, maxDate) => ({
  type: OPEN_FROM_DATE,
  payload: { minDate, maxDate },
})
export const openToDate = (minDate, maxDate) => ({
  type: OPEN_TO_DATE,
  payload: { minDate, maxDate },
})
export const setDates = (fromDate, toDate) => ({
  type: SET_DATES,
  payload: { fromDate, toDate },
})
export const closeCalendar = () => ({
  type: CLOSE_CALENDAR,
  payload: null,
})
